// extracted by mini-css-extract-plugin
module.exports = {"container":"_0fce717cdb--container--21yJd","tooltip-container":"_0fce717cdb--tooltip-container--tVrha","title":"_0fce717cdb--title--3pYPV","text":"_0fce717cdb--text--WrNdC"};